import { render, staticRenderFns } from "./AddStock.vue?vue&type=template&id=3ca16bd3&"
import script from "./AddStock.vue?vue&type=script&lang=js&"
export * from "./AddStock.vue?vue&type=script&lang=js&"
import style0 from "./AddStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports